import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as readerConfigQuery from '@mhe/reader/core/state/configuration/configuration.selectors';
import { ActivatedRoute } from '@angular/router';
import { ApiClientSelectorService } from '@mhe/reader/core/api-client-selector.service';

@Component({
  selector: 'reader-ui-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TimeoutComponent implements OnInit {
  readonly $runtime = this.store.pipe(select(readerConfigQuery.runtime));
  private readonly activatedRoute = inject(ActivatedRoute);

  queryParams$ = this.activatedRoute.queryParams;

  constructor(
    private readonly store: Store,
    private readonly apiClientSelector: ApiClientSelectorService,
  ) { }

  ngOnInit(): void {
    this.apiClientSelector.getApiClient().logout().subscribe();
  }
}
